import * as React from 'react';
import { useState } from 'react';
import PhotoCapture from '../Utility/PhotoCapture';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import useTheme from '@material-ui/core/styles/useTheme';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


interface IDocumentUploadPhotoProps {
    setPhoto: (photo) => void;
    clearDocType: () => void;
    photo: File | undefined
}


const DocumentUploadPhoto: React.FunctionComponent<IDocumentUploadPhotoProps> = ({ setPhoto, clearDocType, photo }) => {
    const theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down('sm'));


    const [dialogOpen, setDialogOpen] = useState(true);

    const toggleOpen = () => {
        if (dialogOpen === true) {
            clearDocType();
            setDialogOpen(!dialogOpen);
        }
    }

    const closeDialog = () => {
        toggleOpen();
    }


    return (
        <Grid container>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h2">
                            Secure Document Management
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Dialog open={dialogOpen} fullScreen={fullscreen} fullWidth={true} maxWidth={"sm"}>
                <PhotoCapture setPhoto={setPhoto} closeDialog={closeDialog} />
            </Dialog>
        </Grid>
    );
}

export default (DocumentUploadPhoto);

